/**
 * event-tabs.js
 */

import React from 'react';
import { useMediaQuery, Tabs, Tab } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import RouteLink from 'routing/route-link';


const useStyles = makeStyles(theme => ({
  tabs: {
    '& .MuiTab-root': {
      minWidth: 'auto',
      borderBottom: `1px solid ${theme.palette.grey.colors[7]}`,
      textTransform: 'none',
      padding: `6px ${theme.spacing(3)}`,
      '&:hover': {
        transition: `${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}`,
        backgroundColor: theme.palette.grey.colors[9]
      }
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.grey.colors[9]
    },
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
      '& > .MuiSvgIcon-root': {
        marginRight: theme.spacing(1)
      }
    }
  },
}));


export default function EventTabs(props) {
  const {
    value,
    basePath,
    style,
    ...extraProps
  } = props;
  const classes = useStyles();
  const dateParam = new URLSearchParams(window.location.search).get('date');
  const xsDown = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });

  return <>
    {value &&
    <div style={style} data-testid="event-tabs" {...extraProps}>
      <Tabs
        indicatorColor="primary"
        textColor="primary"
        variant={xsDown ? 'fullWidth' : 'standard'}
        scrollButtons
        aria-label={`event-select-tabs`}
        className={classes.tabs}
        value={value}
        allowScrollButtonsMobile>
        <Tab
          component={RouteLink}
          value='new'
          label='New Event'
          basePath={basePath}
          pathSectionName='training'
          pathItemName='wizardCreateEvent'
          pathParams={{ eventId: 0 }}
          queryParams={dateParam ? { date: dateParam } : null}
          data-testid='new-event-tab'
        />
        <Tab
          component={RouteLink}
          value='existing'
          label='Existing Event'
          basePath={basePath}
          pathSectionName='training'
          pathItemName='wizardSelectEvent'
          pathParams={{ eventId: null }}
          queryParams={dateParam ? { date: dateParam } : null}
          data-testid='existing-event-tab'
        />
      </Tabs>
    </div>}
  </>;
}